module.exports = __webpack_public_path__ + "static/media/icon_booking.01743c4b.svg";